import Payment from 'payment';

// Mastercard 2-series (2221-2720). The `payment` lib regex misses part of this range.
const MASTERCARD_2_SERIES = /^(222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)/;

export const getCardIssuer = (cardNumber = '') => {
  const issuer = Payment.fns.cardType(cardNumber);

  if (!issuer && MASTERCARD_2_SERIES.test(cardNumber)) return 'mastercard';

  return issuer;
};

export const formatCardNumber = (cardNumber = '') => {
  return cardNumber.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})$/g, '$1 $2 $3 $4');
};

export const sortCreditCards = (creditCards, defaultMissingPriority = 1) => {
  return creditCards.sort(
    (
      { priority: aPriority = defaultMissingPriority },
      { priority: bPriority = defaultMissingPriority }
    ) => aPriority - bPriority
  );
};

export const filterCreditCards = (creditCards, desiredAssociatedProperties) => {
  const associativeProperties = Object.keys(desiredAssociatedProperties);

  const mappedProperties = associativeProperties.reduce(
    (mappedProperties, key) => {
      mappedProperties[key] = desiredAssociatedProperties[key].reduce(
        (obj, value) => {
          if (value) obj[value] = true;
          return obj;
        },
        {}
      );

      return mappedProperties;
    },
    {}
  );

  const checkProperty = (propertyArray = [], propertyType) => {
    if (propertyArray.length) {
      const mappedProperty = mappedProperties[propertyType] || {};
      return propertyArray.some(({ value }) => mappedProperty[value]);
    } else return true;
  };

  return creditCards.filter((creditCard) =>
    associativeProperties.every((property) =>
      checkProperty(creditCard[property], property)
    )
  );
};
